// extracted by mini-css-extract-plugin
export var markdown = "_t3-0";
export var tableWrapper = "_t3-1";